<div class="flex justify-content-between align-items-center mb-4">
    <div class="font-semibold text-xl">
        Tiendas Pendientes del Día
    </div>
</div>

<p-table [value]="pendingBranches()" [columns]="columns" responsiveLayout="scroll" styleClass="p-datatable-sm" scrollHeight="650px">

    <ng-template pTemplate="header" let-columns>
        <tr>
            @for (col of columns; track col.field) {
            <th class="border-bottom-1 surface-border font-semibold">
                {{ col.header }}
            </th>
            }
        </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr>
            @for (col of columns; track col.field) {
            <td>
                @if (col.field === 'status') {
                @let status = rowData | nestedProperty: col.field;
                <p-tag [value]="getStatusLabel(status)" [severity]="getSeverity(status)">
                </p-tag>
                } @else {
                {{ rowData | nestedProperty: col.field }}
                }
            </td>
            }
        </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="columns.length" class="py-4 text-gray-500 text-md" style="text-align: center;">
                No hay tiendas pendientes del día.
            </td>
        </tr>
    </ng-template>

</p-table>
